import { Button } from '@material-ui/core';
import { ReportProblemOutlined } from '@material-ui/icons';

import { ItemAvatar } from 'shared/components';

import { useTLang } from 'intl/intl';

import makeClasses from './ComplaintCard.style';

import type { HTMLAttributes } from 'react';
import type { MozartComplaint } from 'features/mozart-notifications/domain';

export function ComplaintCard(props: Props) {
  const { complaint, ...restProps } = props;

  const lang = {
    btn: {
      label: {
        seen: useTLang({ id: 'notification.mozart.010' }),
        unseen: useTLang({ id: 'notification.mozart.003' }),
      },
    },
    alertChip: {
      label: useTLang({ id: 'notification.mozart.024' }),
    },
  };

  const _classes = makeClasses();

  return (
    <article
      data-seen={complaint.seen}
      data-complaint-reason={complaint.reason}
      className={_classes.card}
      {...restProps}
    >
      <main className={_classes.main}>
        <section>
          <h4 className={_classes.storeName}>{complaint.storeName}</h4>
          <h3 className={_classes.title}>
            {complaint.title}
            <div className={_classes.checkMark} />
          </h3>
          <p className={_classes.description}>{complaint.description}</p>
        </section>
        <ItemAvatar
          alt={complaint.title}
          src={complaint.imageUrl}
          className={_classes.complaintImage}
        />
      </main>

      <footer className={_classes.footer}>
        <Button
          variant='contained'
          className={_classes.btn}
          data-complaint-id={complaint.id}
        >
          {complaint.seen ? lang.btn.label.seen : lang.btn.label.unseen}
        </Button>
        <div className={_classes.alertChip}>
          <ReportProblemOutlined />
          <span>{lang.alertChip.label}</span>
        </div>
        <div>
          {complaint.createdAt.split(' ').map((split, idx) => (
            <p key={`createAt-split-${idx + 1}`} className={_classes.createdAt}>
              {split}
            </p>
          ))}
        </div>
      </footer>
    </article>
  );
}

interface Props extends HTMLAttributes<HTMLElement> {
  complaint: MozartComplaint;
}
